import moment from 'moment';
import _ from 'lodash';

export default {
  methods: {
    // format a set of java dates for chart labels
    getFormattedDates(dateArray) {
      let dates = _.uniq(dateArray);
      let result = [];
      let curr, prev;
      dates.forEach(function(date, index) {
        curr = moment(new Date(date));
        // need full date if first or last date, or year is different from previous year
        if (!prev || prev.year() !== curr.year() || (index === dates.length - 1)) {
          result.push(moment(date).format('M/D/YY'));
        } else {
          result.push(moment(date).format('M/D'));
        }
        prev = curr.clone();
      });
      return result;
    }
  }
};
